import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { notifySuccess } from "../../../components/ui/popup/toastPopup";
import { getMoneyIn, updateMoneyIn } from "../../../service/moneyInAPI";
import Loading from "../../../components/ui/loading";
import { useTranslation } from "react-i18next";
import BreadcrumbsTitle from "../../../components/ui/breadcrumbsTitle";
import { useSchema } from "../../../components/hooks/use-schema";
import { moneyInSchema } from "../../../components/validation/moneyInSchema";
import MoneyInForm from "./moneyInForm";
import { GridContainerSize } from "../../../components/utils/gridContainerSize";

function MoneyInDetail() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm(useSchema(moneyInSchema));

  const { t } = useTranslation();
  const [statusButton, setStatusButton] = useState(true);
  const [dataAll, setDataAll] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const paramsId =
    window.location.pathname.split("/")[
      window.location.pathname.split("/").length - 1
    ];
  const onConfirmForm = async (register) => {
    setIsSubmitting(true);
    let dataAPI = {
      id: dataAll.id,
      status: statusButton,
      money_in_lang: {
        name: register.moneyIn,
        language_code: String(localStorage.getItem("language_form")),
      },
    };
    let statusAPI = await updateMoneyIn(dataAPI);
    if (statusAPI === "OK") {
      notifySuccess({
        title: t("notification_successfully_edited_information"),
      });
      navigate("/money-in");
    }
    await new Promise((resolve) => setTimeout(resolve, 2000));
    setIsSubmitting(false);
  };
  const fetchData = async () => {
    let dataAPI = await getMoneyIn(paramsId);
    let { money_in_lang, status } = dataAPI;
    setDataAll(dataAPI);
    setStatusButton(status);
    setValue("moneyIn", money_in_lang.name);
    setIsLoading(false);
  };
  useEffect(() => {
    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Box>
      <BreadcrumbsTitle
        props={{
          title: t("money_in_info"),
          dataLink: [
            {
              text: t("money_in"),
              link: "/money-in",
            },
            { text: t("money_in_info"), link: null },
          ],
        }}
      />
      {isLoading ? (
        <>
          <Loading />
        </>
      ) : (
        <GridContainerSize>
          <Box p={2}>
            <MoneyInForm
              props={{
                handleSubmit,
                onConfirmForm,
                register,
                errors,
                statusButton,
                setStatusButton,
                isSubmitting,
              }}
            />
          </Box>
        </GridContainerSize>
      )}
    </Box>
  );
}

export default MoneyInDetail;
